export default __webpack_public_path__ + "static/media/customize-invoice-img.c4779c5b.png";